module.exports = __webpack_public_path__ + "img/kurdcell-logo.5316fde5.webp";